import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../core'
import * as externalInstitutions from '../external-institutions'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from(
      externalInstitutions.RESOURCE.payload,
    ),
    description:
      'Unique Entity Identifier (UEI) is a 12-character alphanumeric identifier that the fedeal government uses to identify organizations in its systems. This replaced the DUNS number on April 4, 2022. UEIs are used to track how federal grant money is awarded and dispersed',
    isOptional: true,
    name: 'UEI',
    partialId: PartialId.Standard.create('uei'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
